// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Group } from "../../data/app-core/group";
import { Person } from "../../data/app-core/person";
import { MembershipStatus } from "../../data/app-core/membership-status";
import { OrganizationalUnitDocument } from "./documents/organizational-unit-document";
import { ItemEnvelope } from "./base/item-envelope";

export class OrganizationalUnitEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "OrganizationalUnit");
		if (jsonEnvelope) {
			this.GroupsPool = jsonEnvelope.GroupsPool;
			this.PersonsPool = jsonEnvelope.PersonsPool;
			this.MembershipStatusPool = jsonEnvelope.MembershipStatusPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public GroupsPool: Group[] = [];
	public PersonsPool: Person[] = [];
	public MembershipStatusPool: MembershipStatus[] = [];
	public override Document: OrganizationalUnitDocument = new OrganizationalUnitDocument();
	public override get ItemId(): number { return this.Document.Item.OrganizationalUnitId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}